import React from 'react';

import {
    StyledCard,
    StyledPhotoAddressContainer,
    StyledPropertyCardCTAContainer,
    StyledAddressContainer,
    StyledLinkElement,
    StyledPropertyPanelContainer,
    StyledPropertyPanel,
    PropertyStatus,
} from './StyledComponents';

import './style.scss';

const PropertyCardSkeleton = () => (
    <StyledCard>
        <StyledPhotoAddressContainer className="Bone Bone-dark">
            <PropertyStatus className="Bone Bone-light" />
        </StyledPhotoAddressContainer>

        <StyledPropertyCardCTAContainer>
            <StyledAddressContainer className="Bone Bone-dark" />
            <StyledLinkElement className="Bone Bone-dark" />
        </StyledPropertyCardCTAContainer>

        <StyledPropertyPanelContainer>
            <StyledPropertyPanel className="Bone Bone-dark" />
            <StyledPropertyPanel className="Bone Bone-dark" />
            <StyledPropertyPanel className="Bone Bone-dark" />
        </StyledPropertyPanelContainer>
    </StyledCard>
);

export default PropertyCardSkeleton;
